var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as ServiceUtils from '../../services/utils';
import { Loader } from '../../utils/Loader';
import { useEffect, useState } from 'react';
import * as ServiceObjectif from '../../services/objectif';
import { FormikGenerator, TYPES } from '../../utils/FormikGenerator';
import { Card, Stack } from '@mui/material';
import { FieldArray } from 'formik';
import { IconButton } from '../../utils/IconButton';
import { AddIcon, CloseIcon, EuroIcon, NumberIcon } from '../../utils/Icons';
import { ObjectifsSchema } from '../../utils/ValidationSchema';
import { getIsMobile, getOriginalUser } from '../../services/utilisateur';
var originalUser = getOriginalUser();
export var Objectif = function (_a) {
    var CollaborateurId = _a.CollaborateurId;
    var isMobile = getIsMobile();
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState([]), objectifs = _c[0], setObjectifs = _c[1];
    var _d = useState([]), typesObjectif = _d[0], setTypesObjectif = _d[1];
    var canEdit = originalUser.CanEditObjectif;
    useEffect(function () {
        var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var datas;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            ServiceObjectif.getObjectifListe(CollaborateurId),
                            ServiceUtils.getTypes('Objectif'),
                        ])];
                    case 1:
                        datas = _a.sent();
                        setObjectifs(datas[0]);
                        setTypesObjectif(datas[1]);
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        if (loading) {
            getData();
        }
    }, [loading]);
    if (loading) {
        return _jsx(Loader, {});
    }
    return (_jsx(Card, __assign({ variant: "outlined" }, { children: _jsx(FormikGenerator, { submitLabel: "Enregistrer", datas: { objectifs: objectifs }, validationSchema: ObjectifsSchema, onSubmit: function (_a) {
                var objectifs = _a.objectifs;
                return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, ServiceObjectif.postObjectif(objectifs)];
                            case 1:
                                _b.sent();
                                setLoading(true);
                                return [2 /*return*/];
                        }
                    });
                });
            }, additionalInitialValues: ['objectifs'], fields: [], renderContent: function (_a) {
                var values = _a.values, renderField = _a.renderField, setFieldValue = _a.setFieldValue;
                return (_jsxs(Stack, __assign({ justifyContent: "flex-start", alignItems: "center", padding: 2, spacing: 2 }, { children: [_jsx(FieldArray, { name: 'objectifs', render: function (_a) {
                                var values = _a.form.values, name = _a.name;
                                return values[name] && values[name].length ? (values[name].map(function (item, index) {
                                    var objectif = values[name][index];
                                    if (objectif.Deleted) {
                                        return;
                                    }
                                    return (_jsxs(Stack, __assign({ direction: isMobile ? 'column' : 'row', alignItems: "center", spacing: 1, className: "mt-medium" }, { children: [canEdit && (_jsx(IconButton, __assign({ color: "error", tooltip: "Supprimer l'objectif", onClick: function () {
                                                    setFieldValue("".concat(name, "[").concat(index, "].Deleted"), true);
                                                } }, { children: _jsx(CloseIcon, {}) }))), _jsxs(Stack, __assign({ spacing: 1 }, { children: [renderField({
                                                        label: 'Type',
                                                        name: "".concat(name, "[").concat(index, "].ObjectifTypeId"),
                                                        type: TYPES.SELECT,
                                                        options: typesObjectif ? typesObjectif : [],
                                                        disabled: !canEdit,
                                                    }), renderField({
                                                        label: 'Année',
                                                        name: "".concat(name, "[").concat(index, "].Annee"),
                                                        type: TYPES.TEXT,
                                                        onlyDigits: true,
                                                        disabled: !canEdit,
                                                        endIcon: (_jsx(NumberIcon, { fontSize: "small", color: "disabled" })),
                                                    })] })), _jsxs(Stack, __assign({ spacing: 1 }, { children: [_jsxs(Stack, __assign({ spacing: 1, direction: "row" }, { children: [renderField({
                                                                label: 'Janvier',
                                                                name: "".concat(name, "[").concat(index, "].M").concat(1),
                                                                type: TYPES.TEXT,
                                                                onlyDigits: true,
                                                                disabled: !canEdit,
                                                                endIcon: (_jsx(EuroIcon, { fontSize: "small", color: "disabled" })),
                                                            }), renderField({
                                                                label: 'Février',
                                                                name: "".concat(name, "[").concat(index, "].M").concat(2),
                                                                type: TYPES.TEXT,
                                                                onlyDigits: true,
                                                                disabled: !canEdit,
                                                                endIcon: (_jsx(EuroIcon, { fontSize: "small", color: "disabled" })),
                                                            }), renderField({
                                                                label: 'Mars',
                                                                name: "".concat(name, "[").concat(index, "].M").concat(3),
                                                                type: TYPES.TEXT,
                                                                onlyDigits: true,
                                                                disabled: !canEdit,
                                                                endIcon: (_jsx(EuroIcon, { fontSize: "small", color: "disabled" })),
                                                            }), renderField({
                                                                label: 'Avril',
                                                                name: "".concat(name, "[").concat(index, "].M").concat(4),
                                                                type: TYPES.TEXT,
                                                                onlyDigits: true,
                                                                disabled: !canEdit,
                                                                endIcon: (_jsx(EuroIcon, { fontSize: "small", color: "disabled" })),
                                                            }), renderField({
                                                                label: 'Mai',
                                                                name: "".concat(name, "[").concat(index, "].M").concat(5),
                                                                type: TYPES.TEXT,
                                                                onlyDigits: true,
                                                                disabled: !canEdit,
                                                                endIcon: (_jsx(EuroIcon, { fontSize: "small", color: "disabled" })),
                                                            }), renderField({
                                                                label: 'Juin',
                                                                name: "".concat(name, "[").concat(index, "].M").concat(6),
                                                                type: TYPES.TEXT,
                                                                onlyDigits: true,
                                                                disabled: !canEdit,
                                                                endIcon: (_jsx(EuroIcon, { fontSize: "small", color: "disabled" })),
                                                            })] })), _jsxs(Stack, __assign({ spacing: 1, direction: "row" }, { children: [renderField({
                                                                label: 'Juillet',
                                                                name: "".concat(name, "[").concat(index, "].M").concat(7),
                                                                type: TYPES.TEXT,
                                                                onlyDigits: true,
                                                                disabled: !canEdit,
                                                                endIcon: (_jsx(EuroIcon, { fontSize: "small", color: "disabled" })),
                                                            }), renderField({
                                                                label: 'Août',
                                                                name: "".concat(name, "[").concat(index, "].M").concat(8),
                                                                type: TYPES.TEXT,
                                                                onlyDigits: true,
                                                                disabled: !canEdit,
                                                                endIcon: (_jsx(EuroIcon, { fontSize: "small", color: "disabled" })),
                                                            }), renderField({
                                                                label: 'Septembre',
                                                                name: "".concat(name, "[").concat(index, "].M").concat(9),
                                                                type: TYPES.TEXT,
                                                                onlyDigits: true,
                                                                disabled: !canEdit,
                                                                endIcon: (_jsx(EuroIcon, { fontSize: "small", color: "disabled" })),
                                                            }), renderField({
                                                                label: 'Octobre',
                                                                name: "".concat(name, "[").concat(index, "].M").concat(10),
                                                                type: TYPES.TEXT,
                                                                onlyDigits: true,
                                                                disabled: !canEdit,
                                                                endIcon: (_jsx(EuroIcon, { fontSize: "small", color: "disabled" })),
                                                            }), renderField({
                                                                label: 'Novembre',
                                                                name: "".concat(name, "[").concat(index, "].M").concat(11),
                                                                type: TYPES.TEXT,
                                                                onlyDigits: true,
                                                                disabled: !canEdit,
                                                                endIcon: (_jsx(EuroIcon, { fontSize: "small", color: "disabled" })),
                                                            }), renderField({
                                                                label: 'Décembre',
                                                                name: "".concat(name, "[").concat(index, "].M").concat(12),
                                                                type: TYPES.TEXT,
                                                                onlyDigits: true,
                                                                disabled: !canEdit,
                                                                endIcon: (_jsx(EuroIcon, { fontSize: "small", color: "disabled" })),
                                                            })] }))] }))] }), "".concat(name, "-").concat(index)));
                                })) : (_jsx(_Fragment, {}));
                            } }), canEdit && (_jsx(IconButton, __assign({ tooltip: "Ajouter objectif", onClick: function () {
                                setFieldValue("objectifs", __spreadArray(__spreadArray([], values.objectifs, true), [
                                    ServiceObjectif.newObjectif(CollaborateurId),
                                ], false));
                            } }, { children: _jsx(AddIcon, {}) })))] })));
            } }) })));
};
//# sourceMappingURL=Objectif.js.map